import * as React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import { useDeleteGeneralContact } from 'vendors/queries/useVendorQuery'
import { CircularProgress } from '@mui/material'
import { useSnackbar } from 'snackbar/SnackbarContext'
import { Navigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

type DeleteGeneralContactDialogProps = {
  isOpen: boolean
  onClose: () => void
  vendorId: string
  contactId: string
  contactEmail: string
}

const DeleteGeneralContactDialog: React.FC<DeleteGeneralContactDialogProps> = ({
  isOpen,
  onClose,
  vendorId,
  contactId,
  contactEmail
}) => {
  const { mutate, isPending: isLoading, isSuccess, isError } = useDeleteGeneralContact(vendorId, contactId)
  const { t } = useTranslation()

  const { showSnackbar } = useSnackbar()

  const onDeleteClick = () => {
    mutate()
  }

  React.useEffect(() => {
    if (isSuccess) {
      showSnackbar(t('contact-deleted-successfully'))
      onClose()
    }
  }, [isSuccess, onClose, showSnackbar, t])

  if (isError) {
    return <Navigate to={`/error`} replace />
  }

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{`${t('delete-contact')} ${contactEmail}`}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{t('delete-contact-text')}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2 }}>
        <Button color="grey" onClick={onClose}>
          {t('cancel')}
        </Button>
        <Button
          color="error"
          variant="contained"
          onClick={onDeleteClick}
          disabled={isLoading}
          startIcon={isLoading ? <CircularProgress sx={{ color: 'grey.500' }} size={16} /> : null}
        >
          {t('delete')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteGeneralContactDialog
